import React, { useState, useEffect } from 'react';
import Web3 from 'web3';
import './FaucetPage.css';

const faucetContractABI = [
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_usdtTokenAddress",
        "type": "address"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      }
    ],
    "name": "OwnableInvalidOwner",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      }
    ],
    "name": "OwnableUnauthorizedAccount",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "newAmount",
        "type": "uint256"
      }
    ],
    "name": "AmountPerClaimUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "newCooldown",
        "type": "uint256"
      }
    ],
    "name": "ClaimCooldownUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "user",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "Claimed",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "claimUSDT",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "drainFaucet",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "FaucetDrained",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "FaucetReplenished",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "previousOwner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "OwnershipTransferred",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "renounceOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "replenishFaucet",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "newAmount",
        "type": "uint256"
      }
    ],
    "name": "setAmountPerClaim",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "newCooldown",
        "type": "uint256"
      }
    ],
    "name": "setClaimCooldown",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "transferOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "amountPerClaim",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "claimCooldown",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getFaucetBalance",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "user",
        "type": "address"
      }
    ],
    "name": "getTimeUntilNextClaim",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "lastClaimTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "usdtToken",
    "outputs": [
      {
        "internalType": "contract IERC20",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
];

const faucetContractAddress = '0xB8Db212eDa250E98bC5AC208c554d9eB01bB9734'; // Add the deployed faucet contract address here

function FaucetPage({ account }) {
  const [web3, setWeb3] = useState(null);
  const [faucetContract, setFaucetContract] = useState(null);
  const [lastClaimTime, setLastClaimTime] = useState(0);
  const [canClaim, setCanClaim] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const initWeb3 = async () => {
      if (window.ethereum) {
        const web3Instance = new Web3(window.ethereum);
        setWeb3(web3Instance);
        const contractInstance = new web3Instance.eth.Contract(faucetContractABI, faucetContractAddress);
        setFaucetContract(contractInstance);
      }
    };

    initWeb3();
  }, []);

  useEffect(() => {
    const checkClaimStatus = async () => {
      if (faucetContract && account) {
        const lastClaim = await faucetContract.methods.lastClaimTime(account).call();
        setLastClaimTime(parseInt(lastClaim));
        const now = Math.floor(Date.now() / 1000);
        setCanClaim(now >= parseInt(lastClaim) + 86400); // 86400 seconds = 1 day
      }
    };

    checkClaimStatus();
    const interval = setInterval(checkClaimStatus, 60000); // Check every minute
    return () => clearInterval(interval);
  }, [faucetContract, account]);

  const handleClaim = async () => {
    if (!faucetContract || !account) return;

    setLoading(true);
    try {
      await faucetContract.methods.claimUSDT().send({ from: account });
      alert('USDT claimed successfully!');
      setCanClaim(false);
      setLastClaimTime(Math.floor(Date.now() / 1000));
    } catch (error) {
      console.error('Error claiming USDT:', error);
      alert('Failed to claim USDT. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div className="faucet-page">
      <h1>USDT Faucet</h1>
      <p>Claim 100 mock USDT tokens for testing purposes</p>
      {account ? (
        <div>
          {/* <p>Connected Address: {account}</p> */}
          {canClaim ? (
            <button onClick={handleClaim} disabled={loading} className="claim-button">
              {loading ? 'Claiming...' : 'Claim USDT'}
            </button>
          ) : (
            <p>Next claim available in: {formatTimeRemaining(lastClaimTime)}</p>
          )}
        </div>
      ) : (
        <p>Please connect your wallet to use the faucet</p>
      )}
    </div>
  );
}

function formatTimeRemaining(lastClaimTime) {
  const now = Math.floor(Date.now() / 1000);
  const remainingTime = Math.max(0, lastClaimTime + 86400 - now);
  const hours = Math.floor(remainingTime / 3600);
  const minutes = Math.floor((remainingTime % 3600) / 60);
  return `${hours}h ${minutes}m`;
}

export default FaucetPage;